import { render } from "./Reports.vue?vue&type=template&id=3e3f2532"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
script.render = render

export default script